import { cn } from '~/lib/utils'
import { formatRtp } from './rtp'

/** A version's analytic RTP; a dash when it is not computed. */
export function RtpValue({
  analytic,
  className,
}: {
  analytic: number | null
  className?: string
}) {
  return (
    <span className={cn('font-medium tabular-nums', className)}>
      {formatRtp(analytic)}
    </span>
  )
}
